import styled, { css } from 'styled-components';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${({ theme }) => theme.spacing(4)};
  ${({ border }) =>
    border &&
    css`
      border-bottom: 1px solid ${({ theme }) => theme.colors.elementLine};
    `}
`;

export default HeaderContainer;
